/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Steps_Tool_CallInputs */



/**
* | output |
* | --- |
* | "Tool call" |
*
* @param {Chat_Steps_Tool_CallInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_steps_tool_call = /** @type {((inputs?: Chat_Steps_Tool_CallInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Steps_Tool_CallInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Tool-Aufruf")
	return /** @type {LocalizedString} */ ("Tool call")
});